import { api } from "../../index";
import React, { useCallback, useEffect } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router";

export default function Logout() {
    const nav = useNavigate();

    const logoutFunc = useCallback(async () => {
        await api.post('/auth/logout', {}, { withCredentials: true }).then(() => {
            localStorage.removeItem("userData");
            nav("/login");
        });
    }, [nav]);

    useEffect(() => {
        logoutFunc();
    }, [logoutFunc])

    return (
        <Container className='py-5 d-flex flex-grow-1 justify-content-center align-items-center'>
            <Spinner animation='border' role='status' className='me-2' />
            <span>Logging out...</span>
        </Container>
    );
}